import {
  base_colorContentBorder,
  base_colorSurfaceMuted,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextTertiary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_sm } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.TaskRenderer {
    margin-bottom: ${spacing(4)};
    padding: ${spacing(3)};
    background-color: ${base_colorSurfaceMuted};
    border-radius: 8px;
    border: 1px solid ${base_colorContentBorder};

    .header {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};
      margin-bottom: ${spacing(2)};

      .icon {
        flex-shrink: 0;
      }

      .title {
        ${font_sm};
        font-family: ${font_family_weight_medium};

        &.loading {
          background: linear-gradient(
            90deg,
            ${text_colorTextPrimary} 0%,
            ${text_colorTextTertiary} 25%,
            ${text_colorTextPrimary} 50%,
            ${text_colorTextSecondary} 75%,
            ${text_colorTextPrimary} 100%
          );
          background-size: 200% auto;
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          animation: shimmer 3s linear infinite;
        }
      }

      @keyframes shimmer {
        0% {
          background-position: 200% center;
        }
        100% {
          background-position: 0 center;
        }
      }
    }

    .description {
      ${font_sm};
      margin-bottom: ${spacing(2)};
    }

    .result-content {
      ${font_sm};
      margin-top: ${spacing(3)};
      padding-top: ${spacing(3)};
      border-top: 1px solid ${base_colorContentBorder};
    }
  }
`
